import { createTheme } from "@mui/material/styles";
import shadows, { Shadows } from "@mui/material/styles/shadows";

export const materialCustomTheme = createTheme({
  shadows: shadows.map(() => "none") as Shadows,
  shape: {
    borderRadius: 4,
  },

  typography: {
    fontFamily: ["Geist", "sans-serif"].join(","),
    h1: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },

    h2: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
    h3: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
    h4: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
    h5: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
    h6: {
      fontFamily: ["Inter", "sans-serif"].join(","),
    },
  },
  palette: {
    mode: "light",
    common: {
      black: "#000",
      white: "#fff",
    },
    primary: {
      main: "#ed1c24",
      dark: "#D02533",
      contrastText: "white",
    },
    secondary: {
      main: "#ffebeb",
      dark: "#fb6509",
      contrastText: "white",
    },
    warning: {
      main: "#fff0d8",
      contrastText: "white",
    },
    error: {
      main: "#ef4444",
      contrastText: "white",
    },
    success: {
      main: "#205fbe",
      contrastText: "white",
    },
    text: {
      primary: "#000",
      secondary: "#0E121B",
      disabled: "#525866",
    },
    background: { paper: "#fff", default: "#FFFAFA" },
  },

  components: {
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: {
          color: "#b1b1b1",
          textTransform: "capitalize",
          fontWeight: "500",
          "&.Mui-selected": {
            "svg.fill-svg path": {
              fill: "var(--secondary)",
            },
            "svg.stroke-svg path": {
              stroke: "var(--secondary)",
            },
            "img.bottomnav-icon": {
              filter: "unset",
              opacity: "unset,",
            },
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#fff",
          color: "#fff",
          fontFamily: "Geist, sans-serif",
          fontSize: "12px",
        },
        root: {
          MuiListItemText: {
            root: { fontSize: "14px" },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          color: "#000",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { fontFamily: "Geist, sans-serif" },
        head: {
          background: "transparent",
          border: "none",
          fontFamily: "Geist, sans-serif",
          fontWeight: "600",
          fontSize: ".87rem",
          color: "grey",
        },
        body: {
          background: "transparent",
          boxShadow: "none",
          borderLeft: "none",
          borderRight: "none",
          fontSize: ".75rem",
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          "td, th ": { fontWeight: "600" },
          "&:last-child td, &:last-child th": {
            border: 0,
            borderBottom: "1px solid #E0E0E0",
          },
          " th:last-child": { borderRadius: " 0 5px 0px 0px" },
          " th:first-of-type": { borderRadius: " 5px 0px 0px 0px" },
          "&.MuiTableRow-hover:hover": {
            filter: "brightness(98%)",
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          // minWidth: 650,
          minWidth: "fit-content",
          width: "fit-content",
          "*": { width: "fit-content" },
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: "100%",
          overflowX: "auto",
        },
      },
    },
  },
});
